<nx-default-box-v2>

  <!-- label -->
  <ng-template nxTemplate="label">
    <div class="text-[1rem] font-medium leading-3r mt-[2px] flex items-center gap-1">
      <span>Adresse</span>
      <app-address-indicator-v2 [size]="'small'" [grade]="task()?.address?.geocodingResultGrade"></app-address-indicator-v2>
      <p-progressSpinner
        ariaLabel="loading"
        *ngIf="isLoading()"
        styleClass="w-[16px] h-[16px] black-spinner"
        strokeWidth="8"/>
    </div>
  </ng-template>
  
  <!-- content -->
  <ng-container [ngTemplateOutlet]="displayTemplate"></ng-container>
  
  <!-- actions -->
  <ng-template nxTemplate="mainEnd">
    <ng-container [ngTemplateOutlet]="displayActionsTemplate"></ng-container>
  </ng-template>
</nx-default-box-v2>

<!-- content view mode -->
<ng-template #displayTemplate>
  <div class="flex flex-col">
    @if(task()?.address ; as address ) {
      @if(staticMapUrl(); as mapUrl) {
        @if(shouldShowAddressImage()) {
          <img 
            [src]="mapUrl" 
            alt="Map"
            class="w-full h-auto rounded border border-gray-300 mt-1"
            style="max-height: 300px; object-fit: cover;" />
        }
      }
      @if (address?.name ; as name) {
        <div class="mt-1">
          {{name}}
        </div>
      }
      @if (address?.note ; as note) {
        <div class="mt-1">
          {{note}}
        </div>
      }
      <div class="mt-1">
        {{address?.getAddressStringV2()}}
      </div>
    } @else {
      -
    }
    
  </div>
</ng-template>

<ng-template #displayActionsTemplate>
  <nx-default-button
    class="mr-1"
    [style]="'dark'"
    (click)="edit()"
    [icon]="'icon-edit'"
    [tooltip]="'Bearbeiten'">
  </nx-default-button>
  <nx-default-button
    [style]="'dark'"
    [icon]="'icon-options'"
    [tooltip]="'Mehr'"
    [menuItems]="menuItems()">
  </nx-default-button>
</ng-template>
